/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Button, ButtonProps } from 'reactstrap';

interface Props extends ButtonProps {
  loading: boolean;
  loadingText: string;
  children?: React.ReactNode
}

const LoadingButton = (props: Props) => {
  const { loading, loadingText, children, ...rest } = props;
  return (
    <Button disabled={loading} {...rest}>
      {loading && loadingText ? loadingText : children}
      {loading && <span className='button-loader' />}
    </Button>
  )
}


export default LoadingButton;
